import { render, staticRenderFns } from "./pressResources.vue?vue&type=template&id=1a9f21a2"
import script from "./pressResources.vue?vue&type=script&lang=js"
export * from "./pressResources.vue?vue&type=script&lang=js"
import style0 from "./pressResources.vue?vue&type=style&index=0&id=1a9f21a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports